const POSITIONS_CATEGORY = 'positions'

export const POSITIONS_EVENTS = {
  POSITION_EXPANDED: {
    action: 'Position expanded',
    category: POSITIONS_CATEGORY,
  },
  POSITIONS_VIEW_ALL_CLICKED: {
    action: 'Positions view all clicked',
    category: POSITIONS_CATEGORY,
  },
  EMPTY_POSITIONS_EXPLORE_CLICKED: {
    action: 'Empty positions explore clicked',
    category: POSITIONS_CATEGORY,
  },
  POSITIONS_REFRESH_CLICKED: {
    action: 'Positions refresh clicked',
    category: POSITIONS_CATEGORY,
  },
}

export enum POSITIONS_LABELS {
  dashboard = 'dashboard',
}
